import { useMemo } from 'react';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';
import { useNativeShareTitle } from '#src/app/shared/hooks/share';

import { useGetShareContent } from './content';
import { useOnShareSuccess } from './success';
import { useGetShareTrackingData } from './tracking';

export function useShareOptions(): ShareActionsOptions {
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();
	const onSuccess = useOnShareSuccess();
	const {
		data: {
			initial,
			petition: { displayTitle },
			experiments: { nativeShareTitleExperiment },
		},
	} = usePsfSharePageData();
	const mobileNativeShare = useNativeShareTitle({
		experiment: nativeShareTitleExperiment,
		// Same context as this page's share tracking (`./tracking`).
		surface: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
		petitionTitle: displayTitle,
	});

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getContent,
			getTrackingData,
			onSuccess,
			config: { mobileNativeShare },
		}),
		[getContent, getTrackingData, onSuccess, mobileNativeShare],
	);
}
